import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SolicitudeComponent } from './solicitude.component';

const routes: Routes = [
    {
        path: '',
        component: SolicitudeComponent,
      },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class SolicitudeRoutingModule {}
